export interface NsModalButton {
	id?: number;
	title: string;
	action: () => void;
	icon? : string;
	class? : ButtonClass | string[];
	isEnabled?: () => boolean;
	isDisplayed?: () => boolean;

	buttons?: NsModalButton[];
}

export interface NsModalController {
	close: () => void;
}

export enum ButtonClass {
	default = "btn-default",
	primary = "btn-primary",
	danger = "btn-danger",
	warning = "btn-warning",
	info = "btn-info",
}

export const NsModalDirective = () => {
	return {
		restrict: 'E',
		transclude: true,
		scope: {
			header: "@",
			type: "@",
			buttons: "<",
			class: "<",
			controller: "<"
		},
		template: `
		<div class="bootstrap-dialog type-{{type || 'primary'}}">
			<div class="modal-header">
				<div class="bootstrap-dialog-header">
					<div class="bootstrap-dialog-close-button">
						<button class="close" ng-click="controller.close()">&times;</button>
					</div>
					<div class="bootstrap-dialog-title">{{header}}</div>
				</div>
			</div>
			<div class="modal-body">
				<div class="bootstrap-dialog-body">
					<div class="bootstrap-dialog-message">
						<ng-transclude></ng-transclude>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="bootstrap-dialog-footer">
					<div class="bootstrap-dialog-footer-buttons">

						<button type="button" class="btn" ng-class="button.class || 'btn-default'" ng-click="button.action()" ng-repeat-start="button in buttons" ng-if="!button.buttons" ng-disabled="button.isEnabled && !button.isEnabled()" ng-show="!button.isDisplayed || button.isDisplayed()">
							<span ng-if="button.icon" class="bootstrap-dialog-button-icon {{button.icon}}"></span>
							{{button.title}}
						</button>
						<div class="btn-group" ng-repeat-end ng-if="button.buttons" style="margin-right: 7px">
							<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
								<span ng-if="button.icon" class="bootstrap-dialog-button-icon {{button.icon}}"></span> {{button.title}} <span class="caret"></span>
							</button>
							<ul class="dropdown-menu" role="menu">
								<li ng-repeat="subBtn in button.buttons"><a ng-click="subBtn.action()" href="javascript:void(0)" title="{{subBtn.title}}">{{subBtn.title}}</a></li>
							</ul>
						</div>

					</div>
				</div>
			</div>
		</div>
		`
	}
}

